import React, { useState, useEffect } from 'react';
import api from '../../utils/api';
import '../PageStyles.css';

const About = () => {
  const [page, setPage] = useState(null);
  const [sections, setSections] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await api.get('/pages/about');
        setPage(response.data.page);
        setSections(response.data.sections || []);
      } catch (error) {
        console.error('Failed to fetch about page:', error);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, []);

  if (loading) return <div className="loading">Loading...</div>;

  return (
    <div className="page-container">
      <div className="container">
        <h1>{page?.title || 'About Us'}</h1>

        {sections.map((section) => (
          <div key={section.id} className="content-section">
            {section.title && <h2>{section.title}</h2>}
            {section.image_url && <img src={section.image_url} alt={section.title || 'Section'} />}
            {section.content && <p>{section.content}</p>}
          </div>
        ))}

        {sections.length === 0 && (
          <p>Learn more about our company and what we do.</p>
        )}
      </div>
    </div>
  );
};

export default About;
